import { Pipe, PipeTransform } from '@angular/core';

/**
 * Retorna el texto sin inyectar caracteres invisibles.
 * El quiebre de línea se maneja vía CSS para evitar copiar caracteres especiales.
 *
 * Uso: {{ 'AR_AGRICULTURAL_EXCH' | underscoreWrap }}
 */
@Pipe({
  name: 'underscoreWrap',
  standalone: true
})
export class UnderscoreWrapPipe implements PipeTransform {
  transform(value: string): string {
    if (!value || typeof value !== 'string') return value;
    return value;
  }
}
